import { IkasCategory } from ".";
import { IkasCategoryTranslation } from "./translations";
import { initIkasHTMLMetaData } from "../html-meta-data/init";
import { initIkasCategoryPathItem } from "./path-item/init";

export function initIkasCategory(
  category: IkasCategory,
  locale: string | null
) {
  category.image = category.imageId
    ? { id: category.imageId, isVideo: false }
    : undefined;

  category.metaData && initIkasHTMLMetaData(category.metaData, locale);

  if (category.translations && locale) {
    setTranslations(category, category.translations, locale);
    delete category.translations;
  }
  category.categoryPathItems.map((cPI) =>
    initIkasCategoryPathItem(cPI, locale)
  );
}

function setTranslations(
  category: IkasCategory,
  translations: IkasCategoryTranslation[],
  locale: string
) {
  if (translations && translations.some((t) => t.locale === locale)) {
    const localeTranslations = translations.find((t) => t.locale === locale);

    if (localeTranslations?.name) category.name = localeTranslations.name;
    if (localeTranslations?.description)
      category.description = localeTranslations.description;
  }
}
